import { styled } from '@mui/material'
import { Button } from 'ComponentLibrary/src/atoms/Buttons/Button/Button'

export const PlaceholderButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 400,
    color: theme.palette.customtext.black100,
    '& svg': {
        color: theme.palette.customtext.black54,
    },
}))
